export function cn(...classes: Array<string | null | undefined | false>) {
  return classes.filter(Boolean).join(' ');
}
